import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    override parse(url: string): UrlTree {
        // Optional Step: Do some stuff with the url if needed.

        const fullUrl = url.split('?');
        let baseUrl = fullUrl[0];
        const segments = baseUrl.split('/');
        if (segments.length > 1) {
            segments[1] = segments[1].toLowerCase();
        }
        baseUrl = segments.join('/');
        let queryString = fullUrl[1] || '';
        if (queryString && queryString.length) {
            queryString = `?${queryString}`;
        }
        return super.parse(`${baseUrl}${queryString}`);
    }
}
